import { render, staticRenderFns } from "./packageSelect.vue?vue&type=template&id=64a46aee&scoped=true&"
import script from "./packageSelect.vue?vue&type=script&lang=js&"
export * from "./packageSelect.vue?vue&type=script&lang=js&"
import style0 from "./packageSelect.vue?vue&type=style&index=0&id=64a46aee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a46aee",
  null
  
)

export default component.exports